// test295
(295 && 0);
